
















import {CommonMixin} from "@/shared/services/mixin";
import {Component, Prop, PropSync} from "vue-property-decorator";
import {mixins} from "vue-class-component";

const columns = [
    {
        title: 'STT',
        dataIndex: 'stt',
        key: 'stt',
        width: 80,
        align: 'center',
    },
    {
        title: 'Mã vận đơn',
        dataIndex: 'ladingCode',
        key: 'ladingCode',
        align: 'center',
        scopedSlots: {customRender: 'ladingCode'}
    }
];
@Component({
    name: "StockInFastSuggestTable"
})
export default class extends mixins(CommonMixin) {
    @Prop() dataSource!: any;
    @PropSync('form') formSync!: any;
    columns = columns;

    onSelectChange(selectedRowKeys: string[]) {
        this.formSync.ladingCodes = selectedRowKeys as any;
    }
}
